import { render } from "./Field.vue?vue&type=template&id=723cb72c"
const script = {}

import exportComponent from "/home/runner/work/space-app/space-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__